import './index.scss';

import React, {useContext, useRef} from 'react';
import SVG from "react-inlinesvg";
import Icons from "../../icons";
import {useFormContext} from "react-hook-form";
import {GlobalContext} from "../../context";

function mapValueToString(value) {
    if (value === true) return 'true';
    if (value === false) return 'false';

    return value;
}

function onSelect(event, page, valueEntry, handleSelectAnswer, setValue) {
    console.log('EntryFormItem onSelect', {page, valueEntry});
    event.preventDefault();
    event.stopPropagation();

    const newEntry = handleSelectAnswer(page, valueEntry.value);
    setValue(page.key, mapValueToString(newEntry?.value));
}

function createDescription(page) {
    return [page.label, page.information?.title, page.information?.text]
        .filter(txt => !!txt)
        .join('\n\n');
}

function valueFromResponseArray(responseArray, key) {
    console.log('EntryFormItem valueFromResponseArray', {responseArray, key});
    const valueEntry = responseArray.find(response => response.key === key);
    if (!valueEntry) return [];
    if (Array.isArray(valueEntry.value)) return valueEntry.value;
    return [valueEntry.value];
}

function textFromValues(valueArray, answers) {
    console.log('EntryFormItem textFromValues', {valueArray, answers});
    const selectedAnswers = valueArray.map(value => answers.find(v =>
        v.value === value
        || v.value === 'true' && value === true
        || v.value === 'false' && value === false
    ));
    const selectedText = selectedAnswers.map(answer => answer.label).join(', ');
    return selectedText || "Bitte wählen";
}

export const EntryFormItem = ({page, disabled}) => {
    console.log('EntryFormItem', {formname: page.key, answers: page.answers});
    const {handleSelectAnswer, responseArray} = useContext(GlobalContext);
    const {
        register,
        setValue,
        formState: {errors}
    } = useFormContext();

    const selectionToggle = useRef();
    const selectionElement = useRef();
    const tooltipToggle = useRef();
    const tooltipElement = useRef();

    const valueArray = valueFromResponseArray(responseArray, page.key);
    const valueText = textFromValues(valueArray, page.answers);
    const error = errors[page.key];

    const selectionId = `efi-selection-${page.key}`;
    const tooltipId = `efi-tooltip-${page.key}`;

    console.log('EntryFormItem - render', {
        formname: page.key,
        valueArray,
        valueText,
        answers: page.answers,
        tooltipId,
        selectionId
    });
    return (
        <>
            <div className={`entry-form-item dropdown ${disabled ? 'disabled' : ''}${error ? 'error' : ''}`}>
                <div
                    className="efi-container"
                    id={selectionId}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <div className="efi-content">
                        <div className="efi-title">{`${page.name}${page.required ? ' *' : ''}`}</div>
                        <input
                            className="efi-value efi-hidden"
                            disabled={disabled ?? false}
                            type={page.inputType}
                            {...register(page.key, {
                                required: page.required,
                            })}
                            tabIndex="-1"
                        />
                        <div className="efi-value">{valueText}</div>
                    </div>
                    <div className="efi-dropdown">
                        <a ref={selectionToggle} href="#" role="button">
                            <i className="fa fa-chevron-down"/>
                        </a>
                    </div>
                </div>
                <div ref={selectionElement} className="efi-dropdown-menu dropdown-menu dropdown-menu-right"
                     aria-labelledby={selectionId}>
                    {page.answers.map((valueEntry, index) => (
                        <button
                            type="button"
                            role="menuitem"
                            className={`dropdown-item ${valueArray.includes(valueEntry.value) ? 'selected' : ''}`}
                            key={`select-${index}`}
                            onClick={(event) => onSelect(event, page, valueEntry, handleSelectAnswer, setValue)}
                        >
                            {/*<SVG src={iconMapper(valueEntry.icon)}/>*/}
                            <p>{valueEntry.label}</p>
                        </button>
                    ))}
                </div>
                <div className="efi-description">
                    <SVG src={Icons.form_partial_circle}/>
                </div>
                <div className="efi-description efi-toggle">
                    <a ref={tooltipToggle} href="#" role="button" id={tooltipId} data-toggle="dropdown"
                       aria-haspopup="true" aria-expanded="false">
                        <SVG src={Icons.form_info_open}/>
                        <SVG src={Icons.form_info_close}/>
                    </a>
                    <div ref={tooltipElement} className="dropdown-menu dropdown-menu-right" data-placement="top"
                         aria-labelledby={tooltipId}>
                        <pre>{createDescription(page)}</pre>
                    </div>
                </div>
            </div>
        </>
    );
};
